import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <div className="bg-black border border-[#00B4D8]/30 rounded-2xl p-6 flex flex-col gap-4" data-id="element-349">
      <div className="flex items-center gap-3" data-id="element-350">
        <div className="w-12 h-12 rounded-full bg-[#00B4D8]/20 border border-[#00B4D8]/40 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-351">
          {initials}
        </div>
        <div data-id="element-352">
          <div className="text-[#00B4D8] text-sm" data-id="element-353">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-354">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-355">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-356">"{quote}"</p>
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-357">
      <div className="max-w-5xl mx-auto" data-id="element-358">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-359">
          Lo que dicen los profes que ya lo usan:
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-360">
          +300 profesores de pádel de todo el mundo hispanohablante ya tienen su
          MegaPack
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-361">
          <TestimonialCard initials="CR" stars={5} quote="Compré un domingo a la noche. El lunes entré a la cancha con el plan exacto de la clase. Las 40 clases del Tomo 1 son exactamente lo que necesitaba para mis alumnos principiantes. Nunca más improviso." name="Carlos R." location="Ciudad de México" level="Profesor en Club Deportivo" data-id="element-362" />
          <TestimonialCard initials="ML" stars={5} quote="El sistema del Tomo 3 de víbora y bajada de pared me cambió todo. El primer mes, tres alumnos que llevaban meses estancados subieron de nivel. Los drills del Tomo 5 hacen la diferencia. Los uso en cada clase." name="Miguel L." location="Bogotá, Colombia" level="Instructor en Academia Privada" data-id="element-363" />
          <TestimonialCard initials="AP" stars={5} quote="El Tomo 5 de Drills es único en el mercado. 60 ejercicios listos para usar con 1, 2, 3 o 4 alumnos. Antes tardaba 1 hora en armar una clase para grupos mixtos. Ahora abro el PDF y en 5 minutos tengo todo listo." name="Andrea P." location="Santiago de Chile" level="Profesora Independiente" data-id="element-364" />
          <TestimonialCard initials="JM" stars={5} quote="El sistema de niveles con rúbricas eliminó las preguntas de '¿cuándo paso al siguiente nivel?'. Ahora el alumno lo ve con sus propios números. Y paga el abono más contento porque entiende que avanza de verdad." name="Javier M." location="Lima, Perú" level="Profesor Particular y Academia" data-id="element-365" />
          <TestimonialCard initials="LG" stars={5} quote="Mi tasa de retención pasó del 35% al 75%. Sin cambiar técnicamente lo que doy. Solo aplicando el sistema de fidelización del Tomo 6 y el Abono Blindado del Pádel Pro Business. En 4 meses llené todos mis horarios." name="Laura G." location="Madrid, España" level="Profesora de Pádel" data-id="element-366" />
          <TestimonialCard initials="VR" stars={5} quote="Ahora entrego el Contrato Ético en la primera clase y uso el sistema de abono desde el mes 1. Los alumnos lo aceptaron todos sin problemas. Este mes cobré el 100% antes del día 5. Primera vez en mi vida." name="Valentina R." location="Montevideo, Uruguay" level="Profesora de Pádel" data-id="element-367" />
          <TestimonialCard initials="PM" stars={5} quote="El Kit Anti-Lluvia me salvó el mes de temporada de lluvias. Antes perdía esas clases y ese ingreso. Con el Plan B di 12 clases teóricas y físicas. Cobré el mes completo. Mis alumnos agradecieron el sistema." name="Pablo M." location="Caracas, Venezuela" level="Instructor en Club de Pádel" data-id="element-368" />
        </div>
      </div>
    </section>;
}